import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Filter } from '../models/common/filter';
import { IPagedResult } from '../shared/models/PagedResult';
import { APP_CONFIG } from '../app-config.token';
import { AppConfig } from '../app-config';
import { HolidayPerMonthDto } from '../models/dtos/holiday-per-month-dto';

@Injectable({
  providedIn: 'root',
})
export class HolidayService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/holidays';

  constructor() { }

  getHolidaysPerMonth(
    year: number,
    month: number,
    page: number,
    count: number,
    sortingField: string,
    sortingDirection: string = 'desc',
    filters: Filter[],
  ): Observable<IPagedResult<HolidayPerMonthDto>> {
    let params = new HttpParams()
      .set('page', `${page || 1}`)
      .set('count', `${count || 10}`)
      .set('sortingField', sortingField)
      .set('sortingDirection', sortingDirection)
      .set('filterString', JSON.stringify(filters));

    const url = `${this.API_URL}/${year}/${month}`;

    return this.http.get<IPagedResult<HolidayPerMonthDto>>(url, { params: params }).pipe(
      map((pagedResult) => ({
        ...pagedResult,
        Results: pagedResult.Results.map((r) => ({
          ...r,
          AbsenceDays: r.AbsenceDays.map(ad => ({
            ...ad,
            Date: ad.Date && new Date(ad.Date + 'Z'),
            Absences: ad.Absences.map(a => ({
              ...a,
              StartDate: a.StartDate && new Date(a.StartDate + 'Z'),
              EndDate: a.EndDate && new Date(a.EndDate + 'Z')
            }))
          }))
        }))
      }))
    );
  }
}
